"use client";

import { InfoIcon } from "@/components/ui/atoms/icons";

type EmptyOverlayRecallButtonProps = {
  onRecall: () => void;
};

/**
 * Discreet "?" pill anchored bottom-right of the canvas to re-open the
 * empty-state welcome card after it has been dismissed (or auto-hidden).
 * Visible only when the welcome card is hidden, its purpose is to keep
 * the help discoverable without intruding on a user who is engaged.
 */
export function EmptyOverlayRecallButton({
  onRecall,
}: EmptyOverlayRecallButtonProps) {
  return (
    <button
      type="button"
      onClick={onRecall}
      aria-label="Réafficher l'aide de démarrage"
      title="Réafficher l'aide de démarrage"
      className="absolute bottom-5 right-5 inline-flex h-7 items-center gap-1.5 rounded-full px-3 text-[11px] font-medium text-text-muted bg-bg-surface/70 backdrop-blur-sm border border-border opacity-40 hover:opacity-100 hover:text-text-primary transition-opacity duration-150 cursor-pointer"
      style={{
        boxShadow: "0 0 0 1px rgba(255,255,255,0.04)",
      }}
    >
      <InfoIcon size={12} />
      Aide
    </button>
  );
}
